export const CATEGORY_RENDER_LIMIT = 50;

export type CategoryOption = {
  gcid: string;
  category: string;
};

export const getVisibleCategories = (
  categories: CategoryOption[],
  query: string,
  selectedIds: string[] = [],
  selectedNames: string[] = [],
  limit = CATEGORY_RENDER_LIMIT
) => {
  const normalizedQuery = query.trim().toLowerCase();

  if (normalizedQuery) {
    return categories
      .filter((cat) => cat.category.toLowerCase().includes(normalizedQuery))
      .slice(0, limit);
  }

  const selected = categories.filter(
    (cat) =>
      selectedIds.includes(cat.gcid) || selectedNames.includes(cat.category)
  );
  const selectedKeys = new Set(selected.map((cat) => cat.gcid));
  const remaining = categories.filter((cat) => !selectedKeys.has(cat.gcid));

  return [...selected, ...remaining].slice(0, limit);
};
